import { render } from "./MenuMsModuleOverview.vue?vue&type=template&id=33ae3042&scoped=true"
import script from "./MenuMsModuleOverview.vue?vue&type=script&lang=js"
export * from "./MenuMsModuleOverview.vue?vue&type=script&lang=js"

import "./MenuMsModuleOverview.vue?vue&type=style&index=0&id=33ae3042&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ae3042"]])

export default __exports__